/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupPolicyType } from '../models/BackupPolicyType';
import { HighFrequencyBackupPolicyPlan } from '../models/HighFrequencyBackupPolicyPlan';
import { PitrBackupPolicyPlan } from '../models/PitrBackupPolicyPlan';
import { StandardBackupPolicyPlan } from '../models/StandardBackupPolicyPlan';

export class BackupPolicyPlan {
  'backupPolicyType': BackupPolicyType;
  'standardPlan'?: StandardBackupPolicyPlan | null;
  'highFrequencyPlan'?: HighFrequencyBackupPolicyPlan | null;
  'pitrPlan'?: PitrBackupPolicyPlan | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "backupPolicyType",
      "baseName": "backupPolicyType",
      "type": "BackupPolicyType",
      "format": ""
    },
    {
      "name": "standardPlan",
      "baseName": "standardPlan",
      "type": "StandardBackupPolicyPlan",
      "format": ""
    },
    {
      "name": "highFrequencyPlan",
      "baseName": "highFrequencyPlan",
      "type": "HighFrequencyBackupPolicyPlan",
      "format": ""
    },
    {
      "name": "pitrPlan",
      "baseName": "pitrPlan",
      "type": "PitrBackupPolicyPlan",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackupPolicyPlan.attributeTypeMap;
  }

  public constructor() {
  }
}



